import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Header } from "@/components/news/Header";
import { Ticker } from "@/components/news/Ticker";
import { Hero } from "@/components/news/Hero";
import { Article } from "@/components/news/Article";
import { Quotes } from "@/components/news/Quotes";
import { Sidebar } from "@/components/news/Sidebar";
import { Footer } from "@/components/news/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[#0A0A0B] min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Ticker />
        <div className="grid grid-cols-12 gap-10 lg:gap-16 px-6 sm:px-10 py-20 max-w-[1500px] mx-auto">
          <div className="col-span-12 lg:col-span-8 space-y-24">
            <Article />
            <Quotes />
          </div>
          <div className="col-span-12 lg:col-span-4">
            <Sidebar />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
